import { CardSide } from '../../events/services/what-a-card-shows-of-ratings';
import { PersonOnALine, WhatWasSaidOfThem, whatWasSaidOn } from '../../user/domains/what-a-profile-line-says';
import { NotificationInboxItemDto } from './notification-inbox';

/**
 * The line of the person an inbox entry is from: « Camille D. · Lyon · ★ 4,8 »
 * over the text of the notification. Maude decided it on 20 October 2026,
 * « Oui, l'ajouter », the line of vote A as already built for the page of an
 * outing.
 *
 * NO ID, NO LINE. The API sends the sender's id only when the reader may read
 * about them: an older API, an entry from nobody, and an entry from somebody a
 * block separates from me all come without it, and the entry keeps the look
 * it had. A line drawn without an id would have nowhere to open.
 *
 * THE NAME AS THE INBOX ALREADY WRITES IT. The entry's `senderName` is built by
 * the API, which decides whether the last name is shortened; the line repeats
 * it rather than rebuilding a name of its own that could disagree.
 *
 * WHICH SCORE. The API says which side fits what the entry is about (the
 * organiser score of somebody who invites me to an outing, for example); a
 * side it does not say is the participant one, the side every member has.
 */
export interface InboxSenderLine {
  person: PersonOnALine;
  said: WhatWasSaidOfThem | undefined;
}

const SIDES: readonly CardSide[] = ['organiser', 'participant'];

export function theLineOfAnInboxEntry(
  entry: Pick<NotificationInboxItemDto, 'senderUserId' | 'senderName' | 'senderLine'>,
): InboxSenderLine | undefined {
  const id = typeof entry.senderUserId === 'string' ? entry.senderUserId.trim() : '';
  if (!id) {
    return undefined;
  }
  const line = entry.senderLine && typeof entry.senderLine === 'object' ? entry.senderLine : undefined;
  const side: CardSide = SIDES.includes(line?.['side'] as CardSide) ? (line?.['side'] as CardSide) : 'participant';
  return {
    person: { id, firstName: entry.senderName?.trim() ?? '' },
    said: whatWasSaidOn(line, side),
  };
}
